<template>
  <a-config-provider :locale="locale">
    <router-view />
  </a-config-provider>
</template>

<script>
import zhCN from 'ant-design-vue/es/locale/zh_CN';
import dayjs from 'dayjs';
import 'dayjs/locale/zh-cn';
import { onMounted } from 'vue';
import store from '@/store/pms/landlord/index.js';

dayjs.locale('zh-cn');

export default {
  name: 'App',
  components: {},
  setup() {
    onMounted(() => {
      window.addEventListener('message', function (e) {
        store.dispatch('handleOtaType', e.data);
      });
      document.body.style.setProperty('--vi', '#1890ff');
    });
    return { locale: zhCN };
  },
};
</script>

<style lang="scss">
@use '@/assets/css/main.scss';
@use '@/assets/css/color.scss';
@use '@/assets/css/font.scss';
@use '@/assets/css/ant.scss';
</style>
